/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateItemVo } from './RateItemVo';
import {
    RateItemVoFromJSON,
    RateItemVoFromJSONTyped,
    RateItemVoToJSON,
    RateItemVoToJSONTyped,
} from './RateItemVo';

/**
 * 
 * @export
 * @interface CommissionRateSaveReqVo
 */
export interface CommissionRateSaveReqVo {
    /**
     * 推荐码id列表（勾选的推荐码，同一份分成配置批量应用）
     * @type {Array<number>}
     * @memberof CommissionRateSaveReqVo
     */
    recommendCodeIds: Array<number>;
    /**
     * 适用日期，不传时保持原值不变
     * @type {string}
     * @memberof CommissionRateSaveReqVo
     */
    applyDate?: string;
    /**
     * 分成配置（勾选的附加服务及比例，整体覆盖旧配置）
     * @type {Array<RateItemVo>}
     * @memberof CommissionRateSaveReqVo
     */
    rates?: Array<RateItemVo>;
}

/**
 * Check if a given object implements the CommissionRateSaveReqVo interface.
 */
export function instanceOfCommissionRateSaveReqVo(value: object): value is CommissionRateSaveReqVo {
    if (!('recommendCodeIds' in value) || value['recommendCodeIds'] === undefined) return false;
    return true;
}

export function CommissionRateSaveReqVoFromJSON(json: any): CommissionRateSaveReqVo {
    return CommissionRateSaveReqVoFromJSONTyped(json, false);
}

export function CommissionRateSaveReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionRateSaveReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'recommendCodeIds': json['recommendCodeIds'],
        'applyDate': json['applyDate'] == null ? undefined : json['applyDate'],
        'rates': json['rates'] == null ? undefined : ((json['rates'] as Array<any>).map(RateItemVoFromJSON)),
    };
}

export function CommissionRateSaveReqVoToJSON(json: any): CommissionRateSaveReqVo {
    return CommissionRateSaveReqVoToJSONTyped(json, false);
}

export function CommissionRateSaveReqVoToJSONTyped(value?: CommissionRateSaveReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recommendCodeIds': value['recommendCodeIds'],
        'applyDate': value['applyDate'],
        'rates': value['rates'] == null ? undefined : ((value['rates'] as Array<any>).map(RateItemVoToJSON)),
    };
}

